<template>
  <div class="item-container">
    <router-link class="item gardeshgari" tag="div" to="/agancy">
      <img src="~@/assets/img/main/jazabeha_logo.png" alt="" />
      <div class="desc">
        <h3>تفریحات گردشگری</h3>
        <p>خرید بلیط تفریحات مختلف از آژانس‌های مختلف</p>
      </div>
    </router-link>

    <router-link tag="div" class="item-reverse gardeshgari" to="/restaurants">
      <div class="desc">
        <h6>رستوران‌ها، کافی‌شاپ‌ها، فست فودها</h6>
        <p>از این قسمت میتوانید به لیستی از رستوران های موجود در جزیره کیش دسترسی داشته باشید</p>
      </div>
      <img src="~@/assets/img/main/resturant1.png" />
    </router-link>

    <router-link tag="div" to="/calendar" class="item gardeshgari">
      <img src="~@/assets/img/main/plans.png" alt="" />
      <div class="desc">
        <h6>تقویم رویداد ها</h6>
        <p>مشاهده لیست کامل برنامه‌ها و پلن‌های جشنواره کیش</p>
      </div>
    </router-link>

    <router-link tag="div" class="item-reverse gardeshgari" to="/tornoments">
      <div class="desc">
        <h6 style="text-align: right;font-size: 19px;font-weight: bold;">مسابقات چند جانبه</h6>
        <p>
          مشاهده لیست بازی‌های رایانه‌ای و وضعیت مسابقات برگذار شده به همراه
          آخرین اطلاعات
        </p>
      </div>
      <img src="~@/assets/img/main/tornoment.png" />
    </router-link>

    <router-link tag="div" to="/malls" class="item gardeshgari">
      <img src="~@/assets/img/main/chaleshkharid.png" alt="" />
      <div class="desc">
        <h6>مراکز خرید</h6>
        <p>معرفی مراکز خرید و پاساژ‌های معتبر کیش برای خریدی به یادماندنی</p>
      </div>
    </router-link>

  </div>
</template>

<script>
export default {
  methods:{
    commingsoon(){
      this.$emit('commingsoon',true)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-container {
  width: 100%;
  min-height: 400px;
  .item {
    width: 100%;
    height: 120px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.3) 100%
    );
    border-radius: 30px;
    margin-bottom: 30px;
    padding: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
    .desc {
      text-align: right;
      width: 200px;
      h6 {
        font-family: "sansb";
        font-size: 20px;
        text-align: right;
      }

      p {
        font-size: 10px;
        font-family: "sans";
        text-align: right;
        line-height: 20px;
        margin-bottom: 0;
        transform: scale(0.9);
        width: 108%;
      }
    }
    img {
      width: 110px;
      height: 110px;
      object-fit: contain;
    }
  }

  .item-reverse {
    width: 100%;
    height: 120px;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.3) 100%
    );
    cursor: pointer;
    border-radius: 30px;
    margin-bottom: 30px;
    padding: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
    h6 {
      font-family: "sansb";
      font-size: 12px;
      text-align: right;
      line-height: 20px;
    }
    p {
      font-size: 10px;
      font-family: "sans";
      text-align: right;
      line-height: 20px;
      margin-bottom: 0;
      transform: scale(0.9);
      width: 108%;
    }

    .desc {
      margin-right: 12px !important;
    }
  }
}
</style>
